import {
  flash as flashAction,
  tapFlashError as freeTapFlashError,
  tapFlashSuccess as freeTapFlashSuccess,
  tapFlashWarning as freeTapFlashWarning,
} from '../generic/flash-messages';
import store from '../store';

export const flash = (...args) => store.dispatch(flashAction(...args));

export const tapFlashSuccess = msg => freeTapFlashSuccess(store.dispatch, msg);
export const tapFlashError = msg => freeTapFlashError(store.dispatch, msg);
export const tapFlashWarningMessages = msg => {
  return freeTapFlashWarning(store.dispatch, msg);
};
